import { render, staticRenderFns } from "./DataPropertyImplementationForm.vue?vue&type=template&id=0ea257d6&scoped=true&"
import script from "./DataPropertyImplementationForm.vue?vue&type=script&lang=js&"
export * from "./DataPropertyImplementationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea257d6",
  null
  
)

export default component.exports